import { IDay } from '@/services/calendar/calendar.service';
import { ICalendarEvent } from './TCalendar';

export type ICalendarEventWithRow = ICalendarEvent & { row: number };
export type IDayWithEvents = IDay & { events: Array<ICalendarEvent> };

export function assignEventsToDays(days: Array<IDay>, events: Array<ICalendarEvent>): Array<IDayWithEvents> {
	return days.map((day: any) => {
		day.events = [] as Array<ICalendarEvent>;

		// Sort events by start date
		events.sort((a, b) => {
			if (a.start.toMillis() === b.start.toMillis()) {
				return a.id.localeCompare(b.id);
			}
			return a.start.toMillis() - b.start.toMillis();
		});

		// Add events if
		// End and start belong to the day
		// end and start wraps the day
		// start is before the day and end is after the day
		events.forEach((e) => {
			if (e.end <= day.dt.startOf('day')) {
				return;
			}
			if (e.start >= day.dt.endOf('day')) {
				return;
			}
			day.events.push(e);
		});

		// Assign rows to events
		day.events.forEach((e: ICalendarEvent) => {
			// If the event is already assigned a row we skip it
			if (e.row !== undefined) {
				return;
			}
			// Otherwise assign the first row available
			for (let i = 1; i < 1000; i++) {
				// Check if there is any event in that row
				const eventInRow = day.events.find((e: ICalendarEvent) => e.row === i);
				if (!eventInRow) {
					e.row = i;
					return;
				}
			}
		});

		return day;
	});
}
